/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import { useParams } from 'react-router-dom';

import { useHandleNavigation } from '../../hooks';
import { applicationSettings } from '../../utils';
import uploadPage from '../ClientUpload';
import errorPage from '../Error';
import { IPage } from '..';

const Home = () => {
    const { requestId } = useParams();
    const { navigate } = useHandleNavigation();

    React.useEffect(() => {
        if (requestId && requestId.length > 0) {
            navigate(uploadPage, requestId);
        } else {
            navigate(errorPage, applicationSettings.invalidRequestId);
        }
    }, []);

    return <></>;
};

const homePage: IPage = {
    title: 'Home',
    route: {
        path: '/:requestId',
        element: <Home />,
    },
};

export default homePage;
